module.exports = __webpack_public_path__ + "img/login89.b1d80365.png";